import * as core from '../../../../../../../core'

import { query } from './area-of-concern-by-functional-area.query'

export const RESOURCE = {
  payload: {
    alias: 'area.of.concern.by.functional.area',
    description:
      'Bar chart of area of concern change impacts by functional area',
    name: 'Area of Concern by Functional Area',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
